<template>
    <b-modal v-model="addUserModal" @keydown.esc="dialog = false"
    title="Create User" @hide="resetForm" ok-title="Create User" @ok="create">
        <template #default>
            <b-form ref="form">
                <b-form-group id="fieldset-firstName" label="First Name*" label-for="input-firstName" label-cols="4">
                    <b-form-input id="input-firstName" v-model="model.firstName" name="firstName" required
                        trim></b-form-input>
                </b-form-group>

                <b-form-group id="fieldset-lastName" label="Last Name*" label-for="input-lastName" label-cols="4">
                    <b-form-input id="input-lastName" v-model="model.lastName" name="lastName" required trim></b-form-input>
                </b-form-group>

                <b-form-group id="fieldset-email" label="Email*" label-for="input-email" label-cols="4">
                    <b-form-input id="input-email" v-model="model.email" name="email" type="email" required
                        trim></b-form-input>
                </b-form-group>

                <!-- <b-form-group
                    id="fieldset-password"
                    label="Password*"
                    label-for="input-password"
                    label-cols="4"
                >
                    <b-form-input
                        id="input-password"
                        v-model="model.password"
                        name="password"
                        type="password"
                        required
                        trim
                    ></b-form-input>
                </b-form-group> -->

                <!-- <b-form-group
                    id="fieldset-confirmPassword"
                    label="Confirm Password*"
                    label-for="input-pconfirmPassword"
                    label-cols="4"
                >
                    <b-form-input
                        id="input-confirmPassword"
                        v-model="model.confirmPassword"
                        name="confirmPassword"
                        required
                        ref="password"
                        type="password"
                        trim
                    ></b-form-input>
                </b-form-group> -->

                <user-roles :all-roles="roles" v-model="model.roles" label-cols="4"></user-roles>
            </b-form>
        </template>

        <template #modal-footer="{ ok }">
            <b-button :disabled="submitting" v-if="hasPermissionCreate" size="sm" variant="success" @click="ok()">
                {{ submitting ? 'Creating User...' : 'Create User' }}
            </b-button>
            <b-button :disabled="submitting" size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import UserRoles from '@/components/UserRoles'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    components: { UserRoles },
    name: 'users-createForm',
    props: [],
    mixins: [popupMixins, permissionsMixins],
    data: () => {
        return {
            componentName: 'User',
            escapeKeyUsed: false,
            addUserModal: false,
            model: {
                firstName: '',
                lastName: '',
                email: '',
                /*   password: '',
                confirmPassword: '', */
                roles: [],
                permissions: [],
            },
            emptyFields: [],
            submitting: false,
            hasErrors: false,
        }
    },
    computed: {
        roles() {
            return this.$store.state.roles.items
        },
    },
    watch: {},
    mounted() {
        this.$store.dispatch('roles/fetch', {
            query: '',
            page: 1,
        })

        this.$store.dispatch('permissions/all')
    },
    methods: {
        loadPermissions() { },
        cancel() {
            if (!this.escapeKeyUsed) {
            this.model.firstName = ''
            this.model.lastName = ''
            this.model.email = ''
            this.model.roles = ''
            this.addUserModal = false;
            }
        },
        resetForm() {
            this.model.firstName = ''
            this.model.lastName = ''
            this.model.email = ''
            this.model.roles = ''
        },
        showModal() {
            this.addUserModal = true
        },

        create(bvModalEvt) {
            bvModalEvt.preventDefault()
            console.log('model', this.model)
            const valid = this.$refs.form.checkValidity()

            // Store copy of model for personalization
            const model = { ...this.model }
            console.log('valid', valid)
            if (valid) {
                this.submitting = true
                this.$store
                    .dispatch('users/createUser', this.model)
                    .then(() => {
                        this.model = {
                            firstName: '',
                            lastName: '',
                            email: '',
                            /*    password: '',
                            confirmPassword: '', */
                            roles: [],
                            permissions: [],
                        }
                        this.submitting = false
                        this.addUserModal = false
                        this.$emit('success')
                    })
                    .catch(error => {
                        // show errors
                        this.$emit('error', error, model.email)
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            } else {
                this.genericToast(
                    'User Creation',
                    'Error',
                    'danger',
                    'Form is incomplete, please complete all fields'
                )
                // this.doToast('User!', 'Form Not completed Properly', 'danger')
            }
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
